import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { intlShape, injectIntl } from 'react-intl';
import { RelatedStory as PageCard } from '@justgiving/dna-card';
import defaultAvatar from '../../../static/images/default-avatar.svg';
import { getImageUrlWithTemplate } from '../../helpers/image';
import currencyMap from '../../helpers/currencyMap';
import styles from './FeaturedCard.less';

class FeaturedCard extends Component {
  static propTypes = {
    page: PropTypes.shape({
      projectType: PropTypes.string.isRequired,
      targetCurrency: PropTypes.string.isRequired,
      amountRaised: PropTypes.number.isRequired,
      progress: PropTypes.number.isRequired,
      pitch: PropTypes.string.isRequired,
      numberOfSupporters: PropTypes.number.isRequired,
      projectId: PropTypes.string.isRequired,
      projectUrl: PropTypes.string.isRequired,
      projectImage: PropTypes.shape({
        url: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        cropArea: PropTypes.shape({
          top: PropTypes.number,
          left: PropTypes.number,
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      }),
    }).isRequired,
    avatars: PropTypes.objectOf(PropTypes.string),
    loadAvatars: PropTypes.func.isRequired,
    selectCard: PropTypes.func.isRequired,
    rank: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    intl: intlShape,
  };

  componentDidMount() {
    const { loadAvatars, page } = this.props;

    if (__CLIENT__ && page.items) {
      loadAvatars(page.items.map(p => p.ownerId));
    }
  }

  render() {
    const {
      page: {
        projectId,
        projectUrl,
        projectImage,
        pitch,
        progress,
        numberOfSupporters,
        amountRaised,
        owner,
        ownerId,
        targetCurrency,
        projectType,
      },
      avatars,
      selectCard,
      rank,
      totalCount,
      intl,
    } = this.props;

    return (
      <div styleName="card-container">
        <PageCard
          percentage={progress || 0}
          title={pitch}
          owner={owner}
          numberOfSupporters={numberOfSupporters}
          totalRaised={
            intl.formatNumber(amountRaised, { maximumFractionDigits: 0 }) || 0
          }
          ownerAvatar={
            getImageUrlWithTemplate(
              avatars[ownerId],
              'CrowdfundingSupporterAvatar'
            ) || defaultAvatar
          }
          pageImage={getImageUrlWithTemplate(projectImage.url, 'Size800w')}
          showTotaliser
          currencySymbol={currencyMap[targetCurrency] || '£'}
          pageLink={projectUrl}
          id={projectId}
          styles={null}
          onClick={() =>
            selectCard({
              id: projectId,
              type: projectType,
              url: projectUrl,
              rank,
              totalCount,
            })
          }
        />
      </div>
    );
  }
}

export default injectIntl(CSSModules(FeaturedCard, styles));



// WEBPACK FOOTER //
// ./src/components/Home/FeaturedCard.js